module.exports = __webpack_public_path__ + "static/media/1026170.fcf80ed8.jpg";